import React from "react";
import { AppValue, AppDisbatch } from "../../../../contexts/app";
import PageCard from "./pagecard";
import styles from "./styles.module.css";
import AddPage from "./addpage";
import { useParams, useHistory } from "react-router-dom";
export default function Pages({ setTitle, setOpen }) {
  const { pages } = React.useContext(AppValue);
  const disbatch = React.useContext(AppDisbatch);
  const { appId, pageId } = useParams();
  const history = useHistory();

  React.useEffect(() => {
    const selected = pages.find((p) => p.id === pageId);
    if (selected) {
      setTitle(selected.name);
    }
  }, [pages, pageId]);

  const handleDrop = (page, dragPath, dropPath, child = false) => {
    if (dropPath.includes(page.id)) {
      return;
    }
    const _pages = [...pages];
    //remove from old parent id needed
    if (!page.topLevel) {
      const parent = _pages.findIndex(
        (x) => x.id === dragPath[dragPath.length - 2]
      );
      console.log(parent);
      const childIndex = _pages[parent].subpages.findIndex((x) => x === pageId);
      const children = [..._pages[parent].subpages];
      children.splice(childIndex, 1);
      _pages[parent] = { ..._pages[parent], subpages: children };
    }

    //set page toplvel and order if now toplevel

    if (dropPath.length === 1 && !child) {
      const _page = { ...page };
      _page.topLevel = true;
      const dropIndex = _pages.findIndex(
        (x) => x.id === dropPath[dropPath.length - 1]
      );
      let newOrder = 0;
      const bottom = _pages[dropIndex];
      const top = _pages[dropIndex - 1];
      if (bottom && top) {
        newOrder = bottom.order - (bottom.order - top.order) / 2;
      } else {
        newOrder = bottom.order - 0.1;
      }
      _page.order = newOrder;
      const _pageIndex = _pages.findIndex((x) => x.id === _page.id);
      _pages[_pageIndex] = _page;
    } else if (child) {
      const _page = { ...page };
      _page.topLevel = false;
      const _pageIndex = _pages.findIndex((x) => x.id === _page.id);
      _pages[_pageIndex] = _page;
    }

    //Add to new parent if needed
    if (dropPath.length > 1 && !child) {
      const _dropPage = _pages.findIndex(
        (x) => x.id === dropPath[dropPath.length - 2]
      );
      const children = [..._pages[_dropPage].subpages];
      const _findIndex = children.find(
        (x) => x === dropPath[dropPath.length - 1]
      );
      children.splice(_findIndex, 0, page.id);
      _pages[_dropPage] = { ..._pages[_dropPage], subpages: children };
    } else if (child) {
      const _dropPage = _pages.findIndex(
        (x) => x.id === dropPath[dropPath.length - 1]
      );
      const children = [..._pages[_dropPage].subpages];
      children.push(page.id);
      _pages[_dropPage] = { ..._pages[_dropPage], subpages: children };
    }

    disbatch({ type: "setPages", value: _pages });
    //console.log(_pages);
  };

  const handleNavigate = (page) => {
    history.push(`/${appId}/canvas/pages/${page.id}`);
    setOpen(false);
  };
  return (
    <div className={styles.pages}>
      <AddPage
        pageNames={pages.map((p) => p.name)}
        setOpen={setOpen}
        appId={appId}
      />
      {pages
        .filter((x) => x.topLevel)
        .map((p, index) => {
          return (
            <PageCard
              handleDrop={handleDrop}
              pages={pages}
              onSelect={handleNavigate}
              key={p.id}
              page={p}
              path={[p.id]}
            />
          );
        })}
    </div>
  );
}
